import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {getTagsList, TabelleElementiRML} from "@commons/mapping/DataTablesSchema";
import {TabellaElementiRMLRecord} from "@commons/mapping/CentroDiCostoRecord";
import {addBaseQueryParams, addURI, IdAziendaParams, transformResponse} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";

export const aziendaTabelleApi = createApi({
    reducerPath: 'aziendaTabelleApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    tagTypes: ['aziendaTabelle'],
    endpoints: (builder) => ({
        getAziendaTabellaElementiRML: builder.query<TabelleElementiRML, Partial<IdAziendaParams>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                const queryParams = `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
                return `/azienda/${filter.idAzienda}/tabella/elementi-RML` + queryParams;
            },
            transformResponse,
            providesTags: (result) => getTagsList<TabellaElementiRMLRecord>(result, 'aziendaTabelle'),
        }),
        getElemento: builder.query<TabellaElementiRMLRecord, string | undefined>({
            query: (URI) => {
                // https://stackoverflow.com/questions/69568818/how-to-dynamically-change-base-url-using-redux-toolkit
                // If you pass in a full url (starting with http:// or https://) fetchBaseQuery will skip baseUrl and use the supplied url instead.
                return URI ? URI : `/${URI}`;
            },
            transformResponse: addURI
        }),
        deleteElemento: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
            invalidatesTags: [{type: 'aziendaTabelle', id: 'LIST'}],
        }),

        updateElemento: builder.mutation<Partial<TabellaElementiRMLRecord>, Partial<TabellaElementiRMLRecord> & Pick<TabellaElementiRMLRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PUT', // 'PATCH'
                body: patch,
            }),
            transformResponse,
            invalidatesTags: (result, error, {URI}) => [{type: 'aziendaTabelle', URI}],

        }),
        insertElemento: builder.mutation<Partial<TabellaElementiRMLRecord>, Partial<TabellaElementiRMLRecord>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (payload) => ({
                url: `/azienda/${payload.idAzienda}/tabella/elementi-RML`,
                method: 'POST',
                body: payload,
            }),
            transformResponse,
            invalidatesTags: [{type: 'aziendaTabelle', id: 'LIST'}],
        }),
    }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAziendaTabellaElementiRMLQuery,
    useLazyGetElementoQuery,
    useUpdateElementoMutation,
    useInsertElementoMutation,
    useDeleteElementoMutation
} = aziendaTabelleApi;